import {Link45deg} from "react-bootstrap-icons";
import c from './performedTests.module.css';

/**
 * A run's status as written by the API: pending and in_process while it is
 * queued or running, completed or failed once it is done. The portal
 * synthesises 'success' for runs that already have results.
 *
 * It used to render as the raw lowercase string, which read as API output and
 * gave the one column that says "something went wrong" no visual weight at all.
 */
const STATUS = {
    success:    {label: 'Success',    tone: c.statusOk},
    completed:  {label: 'Success',    tone: c.statusOk},
    pending:    {label: 'Pending',    tone: c.statusBusy},
    in_process: {label: 'In process', tone: c.statusBusy},
    failed:     {label: 'Failed',     tone: c.statusFailed},
    error:      {label: 'Failed',     tone: c.statusFailed},
};

const statusBadge = (cell) => {
    const key = String(cell ?? '').toLowerCase();
    // An unrecognised status still shows - as itself, in neutral - rather than
    // vanishing behind a fallback label.
    const {label, tone} = STATUS[key] || {label: cell || 'Unknown', tone: c.statusNeutral};
    return <span className={`${c.statusBadge} ${tone}`}>{label}</span>;
};

export const columnsTable = (openLabelingModal) => {
    return [
        {
            dataField: 'date',
            text: 'Date',
            // tabular figures: without them 1 is narrower than 0 and no column
            // of numbers lines up down the page
            classes: () => c.numericCell,
            headerStyle: (colum, colIndex) => {
                return {textAlign: 'center', width: '180px', verticalAlign:'middle',padding:'0'};
            }
        }, {
            dataField: 'test_name',
            text: 'Test Name',
            classes: () => 'overFlowHiddenRow',
            headerStyle: (colum, colIndex) => {
                return {textAlign: 'center', overflow:'hidden', verticalAlign:'middle',padding:'0'};
            }
        }, {
            dataField: 'predicted',
            text: 'Predicted Compounds',
            classes: () => `reportFileCenter ${c.numericCell}`,
            headerStyle: (colum, colIndex) => {
                return {width: '120px', textAlign: 'center', verticalAlign:'middle',padding:'0'};
            }
        }, {
            dataField: 'test_status',
            text: 'Status',
            classes: () => 'reportFileCenter',
            headerStyle: (colum, colIndex) => {
                return {width: '120px', textAlign: 'center', verticalAlign:'middle',padding:'0'};
            },
            formatter: (cell) => statusBadge(cell),
        }, {
            dataField: 'report_file',
            text: 'Report File',
            classes: () => 'migrationLogsClass reportFileCenter',
            headerStyle: (colum, colIndex) => {
                return {width: '150px', textAlign: 'center', verticalAlign:'middle',padding:'0'};
            },
            formatter: (cell, row) => {
                return <a style={{fontSize: '16px', whiteSpace: 'nowrap'}}
                          aria-hidden="true"
                          rel="noreferrer"
                          target='_blank'
                          title={cell}
                          href={cell}><Link45deg size={20}/> View </a>
            },
        },
    ];
}
